module.exports = __webpack_public_path__ + "static/img/text2.c9fb943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/text2.png
// module id = RlrL
// module chunks = 0